export default __webpack_public_path__ + "static/media/central_andes_2_8.29c084df.JPG";